import { FormProvider } from 'react-hook-form'
import {
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '../../../../../../components/ui/dialog'
import { BasicInput } from '../../../../../../components/BasicInput'
import { Button } from '../../../../../../components/ui/button'
import useNewTransferModal from './useNewTransferModal'
import { cpfMask } from '../../../../../../../app/utils/cpfFormater'

interface NewTransferModalProps {
  onBack: () => void
}

export default function NewTransferModal({ onBack }: NewTransferModalProps) {
  const { form, submitModal, isLoading } = useNewTransferModal()
  const {
    formState: { errors },
  } = form
  return (
    <DialogContent className="max-w-[90%] md:max-w-[400px]">
      <DialogHeader className="border-b pb-8">
        <DialogTitle className="text-xl font-semibold text-black01">
          Simular transferência
        </DialogTitle>
        <DialogDescription className="!mt-0 text-base text-black04">
          Insira o CPF do destinatário
        </DialogDescription>
      </DialogHeader>

      <form onSubmit={submitModal}>
        <FormProvider {...form}>
          <BasicInput
            name="cpf"
            label="CPF"
            error={errors.cpf?.message}
            onInput={cpfMask}
          />
          <div className="mt-8 flex justify-end gap-2">
            <Button
              type="button"
              variant="outline"
              onClick={onBack}
              className="w-[160px] rounded-full text-primary"
            >
              Voltar
            </Button>
            <Button
              type="submit"
              disabled={isLoading}
              className="w-[160px] rounded-full font-semibold text-white"
            >
              {isLoading ? 'Verificando...' : 'Continuar'}
            </Button>
          </div>
        </FormProvider>
      </form>
    </DialogContent>
  )
}
